<template>
  <v-card 
    class="testi-card" 
    :class="{ 'theme--dark': $vuetify.theme.dark }"
  >
    <div class="quote-mark">
      <v-icon color="primary" size="40" class="quote-icon">mdi-format-quote-close</v-icon>
    </div>
    
    <div class="card-content">
      <div class="rating">
        <v-icon 
          v-for="star in 5" 
          :key="star" 
          :color="star <= rating ? 'amber' : 'grey lighten-2'"
          size="18"
        >
          {{ star <= rating ? 'mdi-star' : 'mdi-star-outline' }}
        </v-icon>
      </div>
      
      <p class="body-1 testimonial-text">
        {{ text }}
      </p>
      
      <v-divider class="my-4"></v-divider>
      
      <div class="author-info">
        <v-avatar
          :size="55"
          class="avatar"
          color="primary"
        >
          <img
            v-if="avatar"
            :src="avatar"
            :alt="name"
          >
          <span v-else class="white--text headline">{{ name.charAt(0) }}</span>
        </v-avatar>
        <div class="author-details">
          <span class="author-name subtitle-1 font-weight-bold">
            {{ name }}
          </span>
          <span class="author-role caption text--secondary">
            {{ role }}
          </span>
        </div>
      </div>
    </div>
    
    <div class="card-accent"></div>
  </v-card>
</template>

<style scoped lang="scss">
@import './testi-card';
</style>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    avatar: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      default: ''
    },
    rating: {
      type: Number,
      default: 5
    }
  }
}
</script>
